'use strict';
angular.module('eclipseApp.myAccount').controller('internetUsageMonthlyCtrl', ['$scope', '$rootScope', '$http', 'uteEndpoint', '$filter', '$stateParams', '$state', function ($scope, $rootScope, $http, uteEndpoint, $filter, $stateParams, $state) {
  var self = this;

  /**
   * takes in the date range from SS and translates the range
   * @param value
   * @returns {string}
   */
  $scope.translateDateRange = function (value) {
    var dates = value.split(' - ');
    var dateBegin = $filter('amDateFormat')(dates[0] + ' 2015', 'MMM D');
    var dateEnd = $filter('amDateFormat')(dates[1], 'MMM D');
    return dateBegin + ' - ' + dateEnd;
  };

  $scope.lineData = null;

  $scope.averageUseData = {
    total: 0,
    included: 0,
    additional: 0,
    overageCharge: 0
  };


  self.init = function () {

    // DC-188: code cleanup, following moved to route resolve

   /*  if ($stateParams.accountNumber && $stateParams.subscriberNo) {
      $rootScope.userInfo.selectedAccountNumber = $stateParams.accountNumber;
      $rootScope.userInfo.selectedSubscriberNo = $stateParams.subscriberNo;
    } else if ((!$stateParams.accountNumber && !$rootScope.userInfo.selectedAccountNumber) || (!$stateParams.subscriberNo && !$rootScope.userInfo.selectedSubscriberNo)) {
      $state.go('myAccount.overview');
    } else {
      if (!$stateParams.accountNumber) {
        $stateParams.accountNumber = $rootScope.userInfo.selectedAccountNumber;
      }
      if (!$stateParams.subscriberNo) {
        $stateParams.subscriberNo = $rootScope.userInfo.selectedSubscriberNo;
      }
    } */

    $scope.accountNumber = $stateParams.accountNumber || $rootScope.userInfo.selectedAccountNumber;
    $scope.subscriberNo = $stateParams.subscriberNo || $rootScope.userInfo.selectedSubscriberNo;

    var summaryUrl = uteEndpoint('v1/productConsolidatedUsageSummary'),
      url = uteEndpoint('v3/monthlyUsage');

    $http.post(summaryUrl, {
      prodSpec: 'hsi',
      accountNumber: $scope.accountNumber,
      subscriptionID: $scope.subscriberNo
    }).then(function (resp) {
        if (resp && resp.data && resp.data.getDataHSIUsageSummary) {
          $scope.usageSummary = resp.data.getDataHSIUsageSummary;
        } else {
          $scope.usageSummary = { error: '50000' };
        }

        $scope.usageSummary.usageMeter = Math.round($scope.usageSummary.usageMeter);

        if ($scope.usageSummary && $scope.usageSummary.usageMeter > 100) {
          $scope.usageSummary.usageMeter = 100;
        }
      },
      function () {
        $scope.usageSummary = { error: '50000' };
        //$scope.dailyChartStatus = "ERROR";
      });

    $http.post(url, {
      accountNumber: $scope.accountNumber,
      subscriptionID: $scope.subscriberNo
    }).then(function (result) {
        if (result) {
          result = result.data;
        }

        console.log('-----------------------------');
        console.log('monthly usage:', result);
        console.log('-----------------------------');

        $scope.monthlyUsage = [];

        if (result && result.getUsageDetails && result.getUsageDetails.monthlyUsageSummary && result.getUsageDetails.monthlyUsageSummary.monthlyUsage) {
          $scope.monthlyUsage = _.sortBy(result.getUsageDetails.monthlyUsageSummary.monthlyUsage, function (monthlyUsage) {
            monthlyUsage.billingPeriod = $scope.translateDateRange(monthlyUsage.billingPeriod);
            return monthlyUsage.date;
          }.bind($scope));
        }

        if (result && result.getUsageDetails && result.getUsageDetails.monthlyUsageSummary && result.getUsageDetails.monthlyUsageSummary.averageMonthlyUsage) {
          $scope.averageUseData = {
            total: result.getUsageDetails.monthlyUsageSummary.averageMonthlyUsage.total,
            included: result.getUsageDetails.monthlyUsageSummary.averageMonthlyUsage.included,
            additional: result.getUsageDetails.monthlyUsageSummary.averageMonthlyUsage.additional,
            overageCharge: result.getUsageDetails.monthlyUsageSummary.averageMonthlyUsage.overageCharge,
            unit: result.getUsageDetails.monthlyUsageSummary.averageMonthlyUsage.unit
          };
        }

        $scope.maxUsage = 0;

        var labels = [],
          chartDataUsed = [],
          chartDataTotal = [],
          multiplier = 1,
          unlimitedUsageFound = false;

        _.each($scope.monthlyUsage, function (usage) {

          labels.push(usage.billingPeriod);

          if (usage.unit === 'GB') {
            multiplier = 1024;
          } else {
            multiplier = 1;
          }

          chartDataUsed.push(usage.total * multiplier);
          if (usage.included === 9999999) {
            // if unlimited then push -1
            chartDataTotal.push(-1);
            unlimitedUsageFound = true;
          } else {
            chartDataTotal.push(usage.included * multiplier);
          }

          $scope.maxUsage += (usage.total * multiplier);

        });

        if (unlimitedUsageFound && $scope.averageUseData){
          $scope.averageUseData.included = 9999999;
        }

        $scope.barData = {
          labels: labels,
          series: [
            chartDataUsed,
            chartDataTotal
          ]
        };

        $scope.barOptions = {
          stackBars: true,
          height: 300,
          fullWidth: false,
          showGrid: false,
          axisX: {
            offset: 10,
            showGrid: false,
            labelInterpolationFnc: function (value) {
              return value;
            }
          },
          axisY: {
            offset: 80,
            onlyInteger: true,
            labelInterpolationFnc: function (value) {
              return $filter('uteCapacity')(value, false);
            }
          }
        };

      },
      function () {
        $scope.barData = { error: '50000' };
        console.log('$scope.barData', $scope.barData);
      });
  };

  self.init();
}]);
